import { useState } from 'react';
import ShareModal from './ShareModal';

function LiveResults({ data, subject }) {
  const [showShare, setShowShare] = useState(false);

  if (!data) return null;

  const { title, asOf, summary, items = [], keyFacts = [], citations = [] } = data;

  return (
    <article className="live-results">

      {/* Header */}
      <div className="live-header">
        <div className="live-badge">
          <span className="live-dot" />
          LIVE
        </div>
        <div className="live-header-text">
          <h1 className="live-title">{title}</h1>
          <span className="live-as-of">🕐 {asOf} · Powered by Perplexity Sonar</span>
        </div>
        <button className="share-btn share-btn--hero" onClick={() => setShowShare(true)}>
          📤 Share
        </button>
      </div>

      {/* Summary */}
      {summary && (
        <div className="live-summary">
          <p>{summary}</p>
        </div>
      )}

      {/* Items */}
      {items.length > 0 && (
        <div className="live-items">
          {items.map((item, i) => (
            <div key={i} className="live-item">
              <div className="live-item-num">{i + 1}</div>
              <div className="live-item-content">
                <p className="live-item-headline">{item.headline}</p>
                {item.detail && <p className="live-item-detail">{item.detail}</p>}
                {item.source && (
                  <span className="live-item-source">📰 {item.source}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Key facts */}
      {keyFacts.length > 0 && (
        <div className="live-facts">
          <h3 className="live-facts-title">⚡ Key Facts</h3>
          <ul className="live-facts-list">
            {keyFacts.map((f, i) => (
              <li key={i}>
                <span className="live-fact-dot" />
                {f}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Citations */}
      {citations.length > 0 && (
        <div className="live-citations">
          <h4 className="live-citations-title">🔗 Sources</h4>
          <div className="live-citations-list">
            {citations.slice(0, 6).map((url, i) => {
              let domain = url;
              try { domain = new URL(url).hostname.replace('www.', ''); } catch (_) {}
              return (
                <a key={i} href={url} target="_blank" rel="noopener noreferrer" className="live-citation-link">
                  {domain}
                </a>
              );
            })}
          </div>
        </div>
      )}

      {showShare && (
        <ShareModal
          title={title}
          url={window.location.href}
          description={summary}
          onClose={() => setShowShare(false)}
        />
      )}
    </article>
  );
}

export default LiveResults;
